import {Observable} from 'rxjs';
import {ofType} from 'redux-observable';
import {mergeMap, catchError} from 'rxjs/operators';

import {combineEpics} from 'web-app/util/redux-observable';
import * as BillPayerObservables from 'web-app/react/entities/bill-payers/epics';
import * as GlobalSearchApi from 'web-app/react/entities/global-search/api';
import {EntityTypes} from 'web-app/react/entities/global-search/model';

import * as Actions from './actions';

const onShowLoad = action$ =>
    action$.pipe(
        ofType(Actions.showEditDepositModal.type),
        mergeMap(({payload}) =>
            Observable.merge(
                GlobalSearchApi.search(payload.deposit.billPayerId, [EntityTypes.BillPayer]).map(({searchItems}) =>
                    Actions.searchForBillPayerSuccess.action(searchItems),
                ),
                BillPayerObservables.fetchAllBillPayersObservable(payload.institutionId, payload.childId),
            ),
        ),
        catchError(e => Observable.of(Actions.searchForBillPayerFailed.action(e))),
    );

const onAddDeposit = action$ =>
    action$.pipe(
        ofType(Actions.showAddDepositModal.type),
        mergeMap(({payload}) =>
            BillPayerObservables.fetchAllBillPayersObservable(payload.institutionId, payload.childId),
        ),
    );

export default combineEpics(onShowLoad, onAddDeposit);
